var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileMinus = function SvgFileMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.882 2a2.85 2.85 0 0 1 2.02.836l3.374 3.376a2.85 2.85 0 0 1 .841 2.023V19.53A2.47 2.47 0 0 1 17.647 22H6.353a2.47 2.47 0 0 1-2.471-2.47V4.47A2.47 2.47 0 0 1 6.352 2zm-7.53 1.176A1.295 1.295 0 0 0 5.059 4.47v15.058a1.296 1.296 0 0 0 1.295 1.294h11.294a1.295 1.295 0 0 0 1.294-1.294V8.823h-4.118a1.53 1.53 0 0 1-1.529-1.53V3.177zm8.471 11.147a.5.5 0 0 1 0 1H9.176a.5.5 0 0 1 0-1zm-.353-7.03a.354.354 0 0 0 .353.353h4.01q-.01-.027-.02-.055a1.7 1.7 0 0 0-.366-.544v-.002L15.07 3.668h-.002a1.7 1.7 0 0 0-.543-.364q-.028-.011-.055-.02z"
  })));
};
export default SvgFileMinus;